'use strict';

module.exports = {
  any: require('lodash/internal/arraySome'),
  bind: require('lodash/internal/bindCallback'),
  defaults: require('lodash/object/defaults'),
  each: require('lodash/collection/forEach'),
  extend: require('lodash/object/assign'),
  find: require('lodash/collection/find'),
  findKey: require('lodash/object/findKey'),
  first: require('lodash/array/first'),
  rest: require('lodash/array/rest'),
  get: require('lodash/object/get'),
  has: require('lodash/object/has'),
  initial: require('lodash/array/initial'),
  isArray: require('lodash/lang/isArray'),
  isEqual: require('lodash/lang/isEqual'),
  isFunction: require('lodash/internal/baseIsFunction'),
  isNull: require('lodash/lang/isNull'),
  isObject: require('lodash/lang/isObject'),
  isString: require('lodash/lang/isString'),
  isUndefined: require('lodash/lang/isUndefined'),
  last: require('lodash/array/last'),
  map: require('lodash/collection/map'),
  noop: require('lodash/utility/noop'),
  object: require('lodash/array/zipObject'),
  omit: require('lodash/object/omit'),
  pick: require('lodash/object/pick'),
  toArray: require('lodash/lang/toArray'),
  union: require('lodash/array/union'),
  keys: require('lodash/object/keys'),
  values: require('lodash/object/values'),
  once: require('lodash/function/once'),
  filter: require('lodash/collection/filter'),
  invoke: require('lodash/collection/invoke'),
  sortBy: require('lodash/collection/sortBy'),
  functions: require('lodash/object/functions'),
  difference: require('lodash/array/difference')
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/marty-lib/modules/mindash.js
 ** module id = 7
 ** module chunks = 0
 **/